"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is HTMLTableElement
 * @param obj The object to check
 */
function isHTMLTableElement(obj) {
    return safeInstanceOf_1.default(obj, 'HTMLTableElement');
}
exports.default = isHTMLTableElement;
//# sourceMappingURL=isHTMLTableElement.js.map